import { Button, SelectChangeEvent } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import ConfigurationHeader from '../../components/heading/ConfigurationHeader';
import { DashboardSelect } from '../../components/Input/Input';
import { GenericPopUp } from '../../components/popup/genericPopUp';
import { doFinalConfigSubmit, getHomePageConfiguration, getMetaData, getMetaDataConfig, updateConfiguration } from '../../services/uiConfigService';
import { BannerTemplate, configurationAttributeType } from '../../types';
import "./HomepageConfiguration.css";
import TransferList from '../../components/transferList/TransferList';
import * as Sentry from "@sentry/react";
import { openPopup } from '../../stateManagement/actions/popupActions';
import { getAllBanners, getConfigFromClientConfig, getFinalBannerTemplates } from '../../services/bannerServices';
import { flatten } from 'lodash';
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions';
import { bannerTemplates } from '../createBanner/bannerTemplates';
import { manageUpdateAccessObj } from '../manageUpdateAccess/manageUpdateAccessTypes';
import ConfigComparePopup from '../../components/popup/ConfigComparePopup';

export interface widgetItem {
    name: string,
    type: string,
    displayName?: string,
    id?: number | string,
    bannerElements?: any
}

const typeSelectOptions = ["banner", "basket", "bucket"];

const defaultOptionMapping: { [key: string]: ({ title: string, value: string }[]) } = {
    banner: [],
    basket: [],
    bucket: [],
}

const HomepageConfiguration = (props:{showBackButton?:boolean}) => {
    const [homepageConfig, setHomepageConfig] = useState<configurationAttributeType[]>([]);
    const [values, setValues] = useState<widgetItem[]>([])
    const [widgetObj, setWidgetObj] = useState<widgetItem>({ name: '', type: '' });
    const [bannerData, setBannerData] = useState<any[]>([]);
    const [nameOptions, setNameOptions] = useState<{ title: string, value: string }[]>([]);
    const [optionMapping, setOptionMapping] = useState<typeof defaultOptionMapping>(defaultOptionMapping);
    const bannerTemplateOptions = useRef<BannerTemplate[]>([]);
    const getSelectOptions = async () => {
        try {
            const clientConfig =  await getMetaDataConfig("clientconfig");
            const basketResp = getConfigFromClientConfig(clientConfig,'order_basket_configuration');
            const bucketResp = getConfigFromClientConfig(clientConfig,'bucket_configuration');
            const finalBannerTemplates = getFinalBannerTemplates(clientConfig);
            const basketOptions = basketResp?.[0]?.value?.map((basket: { id: string }) => (basket.id));
            const bucketOptions = bucketResp?.[0]?.value?.map((bucket: { id: string }) => (bucket.id));
            const bannerOptions: { title: string, value: string }[] = finalBannerTemplates.filter((bannerTempObj) => bannerTempObj.id !== "template28").map(banner => ({ title: banner.displayName ?? banner.label , value: banner.label }))
            setOptionMapping({
                ...optionMapping,
                basket: basketOptions,
                banner: bannerOptions,
                bucket: bucketOptions
            })
            bannerTemplateOptions.current = finalBannerTemplates;
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    useEffect(() => {
        const getAndSetHomepageConfiguration = async () => {
            try {
                const homepage_config = await getHomePageConfiguration();
                setHomepageConfig([homepage_config?.homepageConfig])
            } catch (err) {
                // Sentry.captureException(err);

            }
        }
        getAndSetHomepageConfiguration();
        getSelectOptions();
        const getBannerData = async ()=>{
            try {
                const bannerData:any[] = await getAllBanners();
                const activeBanners = bannerData.filter(data=>data.activeStatus === "active")
                setBannerData(activeBanners);
                console.log(bannerData)
        } catch (err) {
                // Sentry.captureException(err);
            }
        }
        getBannerData();
    }, [])

    const handleWidgetChange = (e: SelectChangeEvent<unknown | typeof typeSelectOptions>) => {
        setWidgetObj({
            ...widgetObj,
            [e.target.name]: e.target.value,
        })
        if (e.target.name === "type") {
            setNameOptions(optionMapping[e.target.value as string])
        }
    }
    function getBannerElements(bannerTemplate?: BannerTemplate){
        if(bannerTemplate){
            if(bannerTemplate.label === "App schemes banner"){
                const appSchemeIds = ["template9","template28"]
                return flatten(bannerData.filter(banner=>appSchemeIds.includes(banner.bannerType)).map(banner=>banner.bannerElements))
            }else{
                return flatten(bannerData.filter(banner=>banner.bannerType == bannerTemplate.id).map(banner=>banner.bannerElements))
            }
        }else{
            return null;
        }
    }
    const handleAdd = () => {
        const temp: widgetItem[] = [...values];
        const index = temp.findIndex((widget: widgetItem) => widget?.name === widgetObj?.name && widgetObj?.type === widget.type);
        if (index !== -1) {
            openPopup("Alert",'This widget is already present!')

        } else {
            if (widgetObj.name && widgetObj.type) {
                const bannerTemplate = bannerTemplateOptions.current.find(data=> data.displayName!=="New App schemes banner" && data.label.toLowerCase() === widgetObj.name.toLowerCase())
                const bannerElements = getBannerElements(bannerTemplate)
                widgetObj.bannerElements = bannerElements;
                widgetObj.displayName = bannerTemplate?.displayName; 
                temp.push(widgetObj);
                widgetObj.id = temp.length;
                setValues([...temp]);
                setWidgetObj({
                    name: '',
                    type: ''
                })
            } else {
                openPopup("Alert",'Please select name and type !!')
            }
        }
    }
    const handleRemove = (currWidget: widgetItem) => {
        const temp: widgetItem[] = [...values];
        const index = temp.findIndex((widget: widgetItem) => widget?.name === currWidget?.name && currWidget?.type === widget.type);
        if (index !== -1) {
            ;
            setValues([...temp?.filter(widget => widget.id !== currWidget.id)]);

        } else {
        }
    }
    const saveConfiguration = async (preview?: boolean) => {
            try {
                await doFinalHomePageConfigSubmit();
            } catch (err) {
                // Sentry.captureException(err);
                console.log("err===", err)
                if (err instanceof Error)
                    openPopup('Error', "Error occured : " + err?.message)
            }
       
    }

    async function doFinalHomePageConfigSubmit() {
        let { appLayoutConfiguration, homepageConfig } = await getHomePageConfiguration();
        homepageConfig.value = values.map((widgetObj: widgetItem) => {
            if(widgetObj.name.toLowerCase() === "promo banner"){
                widgetObj.name = "Coupon Banner";
            }
            return widgetObj;
        });
        let index = appLayoutConfiguration.findIndex((config: { name: string }) => config.name === "homePageWidget");
        appLayoutConfiguration[index] = homepageConfig;
        await doFinalConfigSubmit("retailer_app_layout_configuration",appLayoutConfiguration,undefined,undefined,"all");
    }
    const setHomepageConfigValues = () => {
        try {

            if (homepageConfig.length) {
                if (homepageConfig?.[0].value) {
                    const values: widgetItem[] = homepageConfig?.[0].value
                    const convertedValues = values.map((obj: widgetItem, index: number) => {
                        const registryBannerTemplate = bannerTemplates.find(data=>data.label.toLowerCase() === obj.name.toLowerCase());
                        const bannerTemplate = bannerTemplateOptions.current.find(data=>data.label.toLowerCase() === obj.name.toLowerCase()) ?? registryBannerTemplate;
                        const displayName = !registryBannerTemplate?.displayName ? bannerTemplate?.displayName : registryBannerTemplate.label;
                        const bannerElements = getBannerElements(bannerTemplate);
                        return { ...obj, name: (obj.name === "Coupon Banner"? "Promo Banner" : obj.name), id: index, bannerElements, displayName };
                    })
                    setValues([...convertedValues])
                }
            }
        } catch (err) {
            // Sentry.captureException(err);

        }
    }

    useEffect(() => {
        setHomepageConfigValues();
    }, [homepageConfig,bannerData])

    return (
        <div className='homepage_configuration_container'>
            <ConfigurationHeader heading={"Homescreen Configuration"} showBackButton={props.showBackButton} saveConfiguration={() => saveConfiguration(false)} showConfirmPopup={true} />
            <div className="config_form_container">
                <div className='homepage_select_container'>
                    <DashboardSelect value={widgetObj.type} options={typeSelectOptions} onChange={handleWidgetChange} name="type" label="Type of widget" selectLableId="typeOfWidget" />
                    <DashboardSelect value={widgetObj.name} options={nameOptions} onChange={handleWidgetChange} name="name" label="Name of widget" selectLableId="name" />
                    <span className='homepage_button_container'>
                        <Button variant="contained" className="homepage_submit" onClick={() => { handleAdd() }}>ADD & REVIEW</Button>
                    </span>
                </div>
                <TransferList items={values} handleRemove={handleRemove} setItems={setValues} />

            </div>
        </div>
    );
}

export default HomepageConfiguration